import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-5" }
const _hoisted_3 = { class: "card card-catalog" }
const _hoisted_4 = { class: "mb-4 transition-y card-body" }
const _hoisted_5 = { class: "position-relative mb-3" }
const _hoisted_6 = { class: "image-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 fs-15 mb-0" }
const _hoisted_10 = { class: "fw-medium" }
const _hoisted_11 = { class: "col-12 fs-15 mb-0" }
const _hoisted_12 = { class: "fw-medium" }
const _hoisted_13 = { class: "col-12 fs-15 mb-0" }
const _hoisted_14 = { class: "fw-medium" }
const _hoisted_15 = { class: "col-12 fs-15 mb-0" }
const _hoisted_16 = { class: "fw-medium" }
const _hoisted_17 = { class: "col-12 fs-15 mb-0" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "col-12 fs-15 mb-0" }
const _hoisted_20 = { class: "fw-medium" }
const _hoisted_21 = { class: "col-12 fs-15 mb-0" }
const _hoisted_22 = { class: "fw-medium" }
const _hoisted_23 = { class: "col-lg-7" }
const _hoisted_24 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_25 = { class: "card-body p-4" }
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }
const _hoisted_27 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-8" }
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "col-lg-4" }
const _hoisted_36 = { class: "position-relative" }
const _hoisted_37 = { class: "text-danger" }
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "position-relative" }
const _hoisted_41 = { class: "text-danger" }
const _hoisted_42 = { class: "col-lg-6" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "position-relative" }
const _hoisted_45 = { class: "text-danger" }
const _hoisted_46 = { class: "col-lg-6" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { class: "position-relative" }
const _hoisted_49 = { class: "text-danger" }
const _hoisted_50 = {
  key: 2,
  class: "table-content mt-5"
}
const _hoisted_51 = { class: "d-flex gap-2" }
const _hoisted_52 = ["onClick"]

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import { ItemDataPayload, ItemDataResponse } from "@/types/interface/item";
import { mapOptionMultiselect, urlToObject } from "@/utils/helper";
import { VarianDataPayload } from "@/types/interface/varian";
import { useVarianStore } from "@/stores/management/varian";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import { hasAccess } from "@/utils/helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVarian',
  setup(__props) {

const idItem = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const itemStore = useItemStore();
const varianStore = useVarianStore();
const detailItem = ref<ItemDataResponse>();
const listItem = ref<any>();
const page = ref(1);
const limit = ref(10);
const showTable = ref(false);
const accessPermission = ref<any>([]);

const validationSchema = toTypedSchema(
  zod.object({
    goods_id: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    // msg_code: zod.string().nonempty({ message: "MSG Code is required" }),
    impa_code: zod.string().nonempty({ message: "Impa Code is required" }),
    keyVarian: zod.string().nonempty({ message: "Key is required" }),
    valueVarian: zod.string().nonempty({ message: "Varian is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: goods_id } = useField<string>("goods_id");
const { value: msg_code } = useField<string>("msg_code");
const { value: impa_code } = useField<string>("impa_code");
const { value: keyVarian } = useField<string>("keyVarian");
const { value: valueVarian } = useField<string>("valueVarian");

const clearForm = () => {
  msg_code.value = "";
  impa_code.value = "";
  keyVarian.value = "";
  valueVarian.value = "";
};

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadVarian: VarianDataPayload = {
    goods_id: goods_id.value,
    impa_code: impa_code.value,
    msg_code: msg_code.value,
    key: keyVarian.value,
    value: valueVarian.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await varianStore.dispatchUpdate(
      idItem.value,
      payloadVarian
    );
  } else {
    responseApi.value = await varianStore.dispatchCreate(payloadVarian);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Varian Successfully Updated"
          : "Varian Successfully Added"
      );
      clearForm();
      loadDetailItem();
      window.location.reload();
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadItems = async () => {
  const { success, message } = await itemStore.dispatchGetItems(1, 99);
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items.items,
      "id",
      "name"
    );
  }
};

loadItems();

const loadDetailItem = async () => {
  const { success, message } = await itemStore.dispatchDetail(idItem.value);

  if (success) {
    detailItem.value = await itemStore?.item?.data;
    goods_id.value = detailItem.value?.id;
    showTable.value = true;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    idItem.value = router.currentRoute.value.params.id.toString();
    loadDetailItem();
  }
});

const handleDelete = async (item: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${item.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await varianStore.dispatchDelete(item.id);
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDetailItem();
        } else {
          toast.error(message);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code" },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "TYPE", value: "key" },
  { text: "VALUE", value: "value" },
  { text: "ACTION", value: "action" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: detailItem.value?.image_link,
                class: "rounded-3",
                alt: "detailItem?"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createTextVNode(" MSG CODE : ")),
              _createElementVNode("span", _hoisted_10, _toDisplayString(detailItem.value?.msg_code), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createTextVNode(" IMPA CODE : ")),
              _createElementVNode("span", _hoisted_12, _toDisplayString(detailItem.value?.impa_code), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createTextVNode(" Category : ")),
              _createElementVNode("span", _hoisted_14, _toDisplayString(detailItem.value?.category?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[8] || (_cache[8] = _createTextVNode(" Group Category : ")),
              _createElementVNode("span", _hoisted_16, _toDisplayString(detailItem.value?.groupCategory?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[9] || (_cache[9] = _createTextVNode(" Item : ")),
              _createElementVNode("span", _hoisted_18, _toDisplayString(detailItem.value?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[10] || (_cache[10] = _createTextVNode(" Unit : ")),
              _createElementVNode("span", _hoisted_20, _toDisplayString(detailItem.value?.unitType?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[11] || (_cache[11] = _createTextVNode(" Size : ")),
              _createElementVNode("span", _hoisted_22, _toDisplayString(detailItem.value?.size), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            (_unref(hasAccess)('goods_variant-create'))
              ? (_openBlock(), _createElementBlock("h3", _hoisted_27, "Form Varian Item"))
              : _createCommentVNode("", true),
            _cache[12] || (_cache[12] = _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/management/item"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Item ")
            ], -1))
          ]),
          (!isLoading.value && _unref(hasAccess)('goods_variant-create'))
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", {
                        for: "msg_code",
                        class: "form-label label text-secondary"
                      }, "MSG Code", -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("input", {
                              name: "msg_code",
                              value: detailItem.value?.msg_code+'.',
                              readonly: "true",
                              type: "text",
                              class: "form-control text-dark"
                            }, null, 8, _hoisted_34)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              name: "msg_code",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(msg_code) ? (msg_code).value = $event : null)),
                              placeholder: "",
                              type: "text",
                              class: "form-control text-dark"
                            }, null, 512), [
                              [_vModelText, _unref(msg_code)]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(errors).msg_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", {
                        for: "impa_code",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Impa Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          name: "impa_code",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(impa_code) ? (impa_code).value = $event : null)),
                          placeholder: "Impa Code",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(impa_code)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(errors).impa_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        for: "key",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Varian Type "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          name: "keyVarian",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(keyVarian) ? (keyVarian).value = $event : null)),
                          placeholder: "Varian Type",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(keyVarian)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(errors).keyVarian), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", {
                        for: "value",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Varian Value "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          name: "valueVarian",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(valueVarian) ? (valueVarian).value = $event : null)),
                          placeholder: "Varian Value",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(valueVarian)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(errors).valueVarian), 1)
                    ])
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-12 mt-3" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Add Varian ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true),
          (showTable.value && !isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(_unref(EasyDataTable), {
                  headers: headers,
                  items: detailItem.value?.variant
                }, _createSlots({ _: 2 }, [
                  (_unref(hasAccess)('goods_variant-delete'))
                    ? {
                        name: "item-action",
                        fn: _withCtx((props) => [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("button", {
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (handleDelete(props))
                            }, " Delete ", 8, _hoisted_52)
                          ])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["items"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})